module.exports = require("child_process");


//////////////////
// WEBPACK FOOTER
// external "child_process"
// module id = 159
// module chunks = 0 1